// extracted by mini-css-extract-plugin
export default {"input":"styles_input__fQrjY","error":"styles_error__XwM7K","icon":"styles_icon__VijXw","multiExample":"styles_multiExample__7jcPH"};